import { LazyItemType } from "@obg/common.lazy-loader";
import { IauiVerificationStepContainer } from "@obg/mat.ui.common";
import { CustomerVerificationStepContainer } from "@obg/mat.ui.common/customer-verification";
import { UpdatedTermsAndConditionsContainer } from "@obg/mat.ui.common/terms-and-conditions";
import { CORE_ROUTE } from "@obg/ngx.core";

import { LoginConsentsContainer } from "../consents/login-consents.container";

import { LoginFlowComponentStep } from "./login-flow.model";

export const LOGIN_FLOW_COMPONENTS_MAP_DESKTOP: LoginFlowComponentStep[] = [
	{ key: "t&c", component: UpdatedTermsAndConditionsContainer },
	{ key: "gdprConsent", component: LoginConsentsContainer },
	{
		key: "customer-verification",
		component: CustomerVerificationStepContainer,
	},
	{
		key: "iaui-verification",
		component: IauiVerificationStepContainer,
	},
	{
		key: "deposit-bonus",
		lazyItem: {
			name: "RewardModule",
			path: () => import("@obg/mat.ui.common.reward/src/module"),
			type: LazyItemType.module,
			moduleData: { redirectTo: CORE_ROUTE.home },
		},
	},
	{
		key: "deposit-limit",
		lazyItem: {
			name: "MultiDepositLimitStepModule",
			path: () =>
				import(
					"@obg/mat.ui.common.responsible-gaming/src/deposit-limit/multi/multi-deposit-limit-step/multi-deposit-limit-step.module"
				),
			type: LazyItemType.module,
		},
	},
	{
		key: "deposit",
		lazyItem: {
			name: "DepositModule",
			path: () => import("@obg/common.payment/deposit/deposit.module"),
			type: LazyItemType.module,
			moduleData: {
				paymentIframeHeight: 940,
				hideFooter: true,
				showHeader: false,
				newLoginFlow: true,
			},
		},
		stepHeight: 950,
	},
];

export const LOGIN_FLOW_COMPONENTS_MAP_MOBILE: LoginFlowComponentStep[] = [
	{ key: "t&c", component: UpdatedTermsAndConditionsContainer },
	{ key: "gdprConsent", component: LoginConsentsContainer },
	{
		key: "customer-verification",
		component: CustomerVerificationStepContainer,
	},
	{
		key: "iaui-verification",
		component: IauiVerificationStepContainer,
	},
	{
		key: "deposit-bonus",
		lazyItem: {
			name: "WelcomeBonusUiModule",
			path: () => import("@obg/mat.ui.common/src/bonus/welcome-bonus/welcome-bonus.module"),
			type: LazyItemType.module,
			moduleData: { redirectTo: CORE_ROUTE.home },
		},
	},
	{
		key: "deposit-limit",
		lazyItem: {
			name: "MultiDepositLimitStepModule",
			path: () =>
				import(
					"@obg/mat.ui.common.responsible-gaming/src/deposit-limit/multi/multi-deposit-limit-step/multi-deposit-limit-step.module"
				),
			type: LazyItemType.module,
		},
	},
	{
		key: "deposit",
		lazyItem: {
			name: "DepositModule",
			path: () => import("@obg/common.payment/deposit/deposit.module"),
			type: LazyItemType.module,
			moduleData: {
				hideFooter: true,
				showHeader: false,
				newLoginFlow: true,
			},
		},
	},
];

export enum MgaFlowSteps {
	TermsAndConditions = 1,
	Consents = 2,
	DepositBonus = 3,
	Deposit = 4,
}

export enum SgaFlowSteps {
	TermsAndConditions = 1,
	Consents = 2,
	DepositBonus = 3,
	DepositLimit = 4,
	Deposit = 5,
}

export type JurisdictionFlowSteps = typeof MgaFlowSteps | typeof SgaFlowSteps;
